import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { PublicAvailableProductType } from '@web/features/product';
import { PublicSalesResponse } from '@web/shared/module/shop';
import { MultimediaResponse } from '@web/shared/module/multimedia';

@jsonObject
export class PublicAvailableProductResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(String)
  public readonly type!: PublicAvailableProductType;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile!: MultimediaResponse;

  @jsonMember(PublicSalesResponse)
  public readonly sales!: PublicSalesResponse;
}
